class BoostStickyCta extends HTMLElement {
  connectedCallback() {
    this.hero = document.querySelector('.boost-secondary-hero');
    this.packs = document.querySelector('.boost-collection');
    if (!this.hero || !this.packs || window.Shopify?.designMode) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    const heading = this.packs.querySelector('h2');
    const target = heading || this.packs.closest('[id]');
    if (!target?.id) return;
    target.classList.add('boost-sticky-target');
    this.querySelector('a').href = `#${target.id}`;
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    }, options);
    const update = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        const hero = this.hero.getBoundingClientRect();
        const packs = this.packs.getBoundingClientRect();
        const packsVisible = packs.top < innerHeight && packs.bottom > 0;
        this.hidden = innerWidth > 749 || hero.bottom > 0 || packsVisible;
      });
    };
    window.addEventListener('scroll', update, { ...options, passive: true });
    window.addEventListener('resize', update, options);
    this.observer = new ResizeObserver(update);
    this.observer.observe(this.hero);
    this.observer.observe(this.packs);
    update();
  }
  disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
}
if (!customElements.get('boost-sticky-cta')) customElements.define('boost-sticky-cta', BoostStickyCta);
